import "./index.scss";

import React, { Component } from "react";

import CardContainer from "../CardContainer";
import Loading from "../Loading";
import PropTypes from "prop-types";
import Title from "../Title";
import { changeMenu } from "../../actions/themeActions";
import { connect } from "react-redux";
import { getAttendants } from "../../actions/dataActions";
import {Calendar, momentLocalizer} from "react-big-calendar";
import moment from "moment";

//Redux

class index extends Component {


  componentDidMount() {
    this.props.changeMenu(this.props.location.pathname.slice(1));
    this.props.getAttendants();
  }

  titleize(text) {
    let words = text.toLowerCase().split(" ");

    for (let a = 0; a < words.length; a++) {
      let w = words[a];
      if (words[a].length > 2) {
        words[a] = w[0].toUpperCase() + w.slice(1);
      }
    }

    return words.join(" ");
  }

  dateAdjust(text) {
    let date = text.split("-");
    return `${date[2]}/${date[1]}`;
  }

  render() {
    const { attendants, theme, showMenu, loadingAttendants } = this.props;

    let attendantsBirthdayArr = [];
    attendants.map(attendant =>
      attendant.pessoa.aniversarianteDoMes
        ? attendantsBirthdayArr.push({
            name: this.titleize(attendant.pessoa.nome),
            date: this.dateAdjust(attendant.pessoa.dataNascimento)
          })
        : null
    );
    attendantsBirthdayArr.sort(
      (a, b) => a.date.slice(0, 2) - b.date.slice(0, 2)
    );

    return (
      <div id="Birthdays" className={showMenu ? `blur` : ""}>
        { !this.iscalendar &&
            <div>
        <Title text={`Aniversários do mês`} type={`SECTION`} theme={theme}/>
        {loadingAttendants ? (
          <Loading />
          ) : attendantsBirthdayArr.length > 0 ? (
          <CardContainer
          data={attendantsBirthdayArr}
          theme={theme}
          cardBirthday
          />
          ) : (
          <p>Nenhum aniversariante no mês.</p>
          )}
            </div>
        }

      </div>
    );
  }
}

index.propTypes = {
  getAttendants: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
  loadingAttendants: PropTypes.bool.isRequired,
  showMenu: PropTypes.bool.isRequired,
  changeMenu: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  theme: state.theme.theme,
  attendants: state.data.attendants,
  loadingAttendants: state.data.loadingAttendants,
  showMenu: state.theme.showMenu
});

export default connect(mapStateToProps, { changeMenu, getAttendants })(index);
